import { surveyLocalization } from "survey-core";
import { settings } from "survey-creator-core";
import locales from "../../constants/locales";
import './as';
import './bn';
import './gu';
import './kn';
import './ml';
import './mr';
import './or';
import './pa';
import './ta';
import './te';
import './ur';
import './hi';

// Override the maximum selected locales limit (default is 7)
settings.translation.maximumSelectedLocales = 12;

locales.forEach(locale => {
  surveyLocalization.localeNames[locale.code] = locale.name;
});
